<script>
export default {
  props: {
    modelValue: { type: [Object, Array], default: () => ({}) },
    inboxes: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  computed: {
    normalizedValue() {
      // actionQueryGenerator wraps objects in array ao salvar — suporta ambos os formatos
      const v = this.modelValue;
      if (Array.isArray(v)) return v[0] || {};
      if (v && typeof v === 'object') return v;
      return {};
    },
    selectedInboxId: {
      get() { return this.normalizedValue.inbox_id || null; },
      set(id) {
        this.$emit('update:modelValue', { inbox_id: id, message: this.messageText });
      },
    },
    messageText: {
      get() { return this.normalizedValue.message || ''; },
      set(text) {
        this.$emit('update:modelValue', { inbox_id: this.selectedInboxId, message: text });
      },
    },
    inboxOptions() {
      return this.inboxes
        .filter(i => ['Channel::Instagram', 'Channel::Whatsapp', 'Channel::FacebookPage'].includes(i.channel_type))
        .map(i => ({ id: i.id, name: i.name }));
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 w-full">
    <select
      v-model="selectedInboxId"
      class="w-full rounded-lg px-3 py-2 text-sm bg-n-alpha-1 outline outline-1 outline-n-weak dark:outline-n-strong focus:outline-2 focus:outline-n-brand"
    >
      <option :value="null" disabled>
        Selecionar canal de envio...
      </option>
      <option v-for="inbox in inboxOptions" :key="inbox.id" :value="inbox.id">
        {{ inbox.name }}
      </option>
    </select>
    <textarea
      v-model="messageText"
      rows="3"
      placeholder="Mensagem... Use {{sender_name}}, {{message}}"
      class="w-full rounded-lg px-3 py-2 text-sm bg-n-alpha-1 outline outline-1 outline-n-weak dark:outline-n-strong resize-none focus:outline-2 focus:outline-n-brand"
    />
  </div>
</template>
